import React, { useEffect } from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import ContactContent from './components/ContactContent'

function Contact() {
  useEffect(() => {
    document.title = 'Agência Dorac - Contato'
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className='relative w-full bg-dorac-bg font-display text-dorac-ink'>
      <Header />
      <ContactContent />
      <Footer />
    </main>
  )
}

export default Contact
